import styled from "@emotion/styled";
import { FormInstance } from "antd";
import { FC } from "react";
 import CampaignDescriptionForm from "./CampaignDescriptionForm";
import CampaignImageCard from "./CampaignImageCard";
import CampaignSubImageCard from "./CampaignSubImageCard";

interface MainCreateCampaignProps {
  form: FormInstance;
  setCheckIsActive: (checkIsActive: boolean) => void;
  checkIsActive: boolean;
  setContent: (content: string) => void;
  content: string;
}

const MainCreateCampaign: FC<MainCreateCampaignProps> = ({
  form,
  checkIsActive,
  setCheckIsActive,
  content,
  setContent,
}) => {
  return (
    <FormWrapper>
      <CampaignImageCard is_active={checkIsActive}  setCheckIsActive={setCheckIsActive} />
      <CampaignSubImageCard is_active={checkIsActive}  setCheckIsActive={setCheckIsActive} /> 
      <CampaignDescriptionForm content={content} setContent={setContent} setCheckIsActive={setCheckIsActive} is_active={checkIsActive} />
    </FormWrapper>
  );
};

export default MainCreateCampaign;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;
